
const digest = 'ba3709511924378e80b984e3372363277bc6827bd1e9ea4db1d08c041d2f8561';
const classes = {"stock":"_stock_1rr8u_1","inStock":"_inStock_1rr8u_6","uponInquiry":"_uponInquiry_1rr8u_9"};
const css = `._stock_1rr8u_1 {
  display: flex;
  gap: 5px;
  font-size: 14px;
}
._stock_1rr8u_1 ._inStock_1rr8u_6 {
  color: green;
}
._stock_1rr8u_1 ._uponInquiry_1rr8u_9 {
  color: #FF9D2A;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  